import { makeApiUrl, UrlQuery } from "../../utils/Api";
import { ReturningThunk } from "../actions/All";

/**
 * A low-level action which GETs an HTTP resource.
 * This will automatically use the user token if necessary.
 * @param url The location.
 * @param query Any url queries to include.
 */
export const get = <T>(url: string, query?: UrlQuery[]): ReturningThunk<Promise<T>> => async (
	_dispatch,
	getState
) => {
	url = makeApiUrl(url, getState().user.token, query);
	const response = await fetch(url, { cache: "no-store", credentials: "include" });
	if (!response.ok) {
		throw new Error(response.statusText);
	}
	return response.json();
};

/**
 * A low-level action which POSTs an HTTP resource.
 * This will automatically use the user token if necessary.
 * @param url The location.
 * @param query Any url queries to include.
 */
export const post = <T>(
	url: string,
	payload: any,
	query?: UrlQuery[]
): ReturningThunk<Promise<T>> => async (_dispatch, getState) => {
	url = makeApiUrl(url, getState().user.token, query);
	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		},
		credentials: "include",
		body: JSON.stringify(payload)
	});
	if (!response.ok) {
		throw new Error(response.statusText);
	}
	return response.json();
};

/**
 * A low-level action which PUTs an HTTP resource.
 * This will automatically use the user token if necessary.
 * @param url The location.
 * @param query Any url queries to include.
 */
export const put = <T>(
	url: string,
	payload: any,
	query?: UrlQuery[]
): ReturningThunk<Promise<T>> => async (_dispatch, getState) => {
	url = makeApiUrl(url, getState().user.token, query);
	const response = await fetch(url, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json"
		},
		credentials: "include",
		body: JSON.stringify(payload)
	});
	if (!response.ok) {
		throw new Error(response.statusText);
	}
	return response.json();
};

/**
 * A low-level action which DELETEs an HTTP resource.
 * This will automatically use the user token if necessary.
 * @param url The location.
 * @param query Any url queries to include.
 */
export const ddelete = (url: string, query?: UrlQuery[]): ReturningThunk<Promise<void>> => async (
	_dispatch,
	getState
) => {
	url = makeApiUrl(url, getState().user.token, query);
	const response = await fetch(url, {
		method: "DELETE",
		credentials: "include"
	});
	if (!response.ok) {
		throw new Error(response.statusText);
	}
};
